import { FileMetadata } from "@/shared/components/FileMetadataAndTopics/FileMetadata";
import { UpdateFileTags } from "@/shared/components/FileMetadataAndTopics/UpdateFileTags";
import { RobotoPrincipalUnderlineLink } from "@/shared/components/principal/RobotoPrincipalUnderlineLink.tsx";
import { FileRecord } from "@/shared/domain/files";
import { formatByteSize } from "@/shared/text";

import styles from "./FileDetails.module.css";

interface FileDetailsProps {
  fileRecord: FileRecord;
}

export function FileDetails({ fileRecord }: FileDetailsProps) {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.sectionHeader}>Size</div>
        <div className={styles.sectionContent}>
          {fileRecord?.size !== undefined && formatByteSize(fileRecord.size)}
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>Last Modified</div>
        <div className={styles.sectionContent}>
          {fileRecord?.modified !== undefined &&
            new Date(fileRecord?.modified).toLocaleString()}
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>Source</div>
        <div className={styles.sectionContent}>
          <RobotoPrincipalUnderlineLink
            principal={fileRecord.created_by}
            icon
          />
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>Tags</div>
        <UpdateFileTags fileId={fileRecord.file_id} />
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>Metadata</div>
        <FileMetadata fileId={fileRecord.file_id} />
      </div>
    </div>
  );
}
